import type { MutationTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { AdminState } from "./state";
import type { IUserProfile } from "@/interfaces";

export const mutations: MutationTree<AdminState> = {
  setUsers(state, payload: IUserProfile[]): void {
    state.users = payload;
  },
  setUser(state, payload: IUserProfile): void {
    const users = state.users.filter(
      (user: IUserProfile) => user.id !== payload.id,
    );
    users.push(payload);
    state.users = users;
  },
};

const NS = "admin/";

export const commitSetUser = (
  store: Store<State>,
  payload: IUserProfile,
): void => {
  store.commit(`${NS}setUser`, payload);
};

export const commitSetUsers = (
  store: Store<State>,
  payload: IUserProfile[],
): void => {
  store.commit(`${NS}setUsers`, payload);
};
